import CatalogV2Api from '@lambda/apis/src/catalog-v2';
import { SkuT } from '@lambda/apis/src/catalog-v2/types';
import settings from '@/settings';

/** SKUs per request. MsCatalog2 caps the page at 50. */
export const COMPATIBLE_PAGE_SIZE = 12;

/** Products one request can ask about. MsCatalog2 rejects more. */
export const MAX_COMPATIBLE_PRODUCTS = 20;

export type CompatiblePageT = {
  /** One SKU per compatible product, each with its product, in MsCatalog2's order. */
  items: SkuT[];
  /** Where the next page starts, or null once every SKU has been read. */
  nextOffset: number | null;
};

/**
 * One page of the SKUs MsCatalog2 links as compatible with any of
 * `productIds` ("More accessories"): one per compatible product, with its
 * cheapest in-stock offer first, ordered by best sellers. The products asked
 * about are never among them.
 */
export const fetchCompatiblePage = async (
  productIds: string[],
  offset = 0,
): Promise<CompatiblePageT> => {
  const { items = [], total = 0 } = await new CatalogV2Api(
    settings.store,
  ).getCompatibleSkus(productIds, {
    limit: COMPATIBLE_PAGE_SIZE,
    offset,
  });
  const next = offset + items.length;

  return {
    items,
    nextOffset: items.length > 0 && next < total ? next : null,
  };
};
